import { render, staticRenderFns } from "./WxpayConfig.vue?vue&type=template&id=6b0ce0a4&scoped=true"
import script from "./WxpayConfig.vue?vue&type=script&lang=js"
export * from "./WxpayConfig.vue?vue&type=script&lang=js"
import style0 from "./WxpayConfig.vue?vue&type=style&index=0&id=6b0ce0a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0ce0a4",
  null
  
)

export default component.exports